import { render, staticRenderFns } from "./ExperienceCard.vue?vue&type=template&id=bf3b8ccc&scoped=true"
import script from "./ExperienceCard.vue?vue&type=script&lang=js"
export * from "./ExperienceCard.vue?vue&type=script&lang=js"
import style0 from "./ExperienceCard.vue?vue&type=style&index=0&id=bf3b8ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3b8ccc",
  null
  
)

export default component.exports